export default "__VITE_ASSET__au9KLm6x__"